import { UserAccountType } from './UserAccountType';

export class UserAccount {
  id?: number;
  kratosId?: string;
  name: string = 'anonymous';
  type = UserAccountType.Anonymous;
  verified: boolean = false;
  uninitialized: boolean = false;
  constructor(uninitialized?: boolean) {
    this.uninitialized = !!uninitialized;
  }
}
